// utils/changeFavicon.ts
export const changeFavicon = (url: string) => {
    const favicon: HTMLLinkElement | null = document.querySelector('#favicon');
    if (favicon) {
      favicon.href = url;
    } else {
      const link = document.createElement('link');
      link.id = 'favicon';
      link.rel = 'icon';
      link.href = url;
      document.head.appendChild(link);
    }
  };
  